class AuthStorage {
  constructor() {
    this.LOCAL_COUNTDOWN_TIME_OTP = "time-otp";
  }

  get timeOtp() {
    const temp = localStorage.getItem(this.LOCAL_COUNTDOWN_TIME_OTP);
    return temp ? parseInt(temp): null;
  }
  set timeOtp(data) {
    localStorage.setItem(this.LOCAL_COUNTDOWN_TIME_OTP, data);
  }

  clear() {
    localStorage.removeItem(this.LOCAL_COUNTDOWN_TIME_OTP);
  }
}

export default new AuthStorage();
